export const ITANI_NETWORK = {
  chainId: '0x494d4551',
  chainIdDecimal: 1229800785,
  name: 'iTani Network Chain',
  chainName: 'iTani Network Chain',
  home: 'https://itaninetworkchain.com',
  rpc: 'https://node.itaninetworkchain.com/jsonrpc',
  nodeRpc: 'https://node.itaninetworkchain.com/jsonrpc',
  explorer: 'https://node.itaninetworkchain.com/explorer',
  testnet: {
    chainId: '0x494d4552',
    chainIdDecimal: 1229800786,
    name: 'iTani Network Chain Testnet',
    home: 'https://testnet.itaninetworkchain.com/',
    rpc: 'https://testnet.itaninetworkchain.com/jsonrpc',
    explorer: 'https://testnet.itaninetworkchain.com/explorer',
  },
  token: {
    symbol: 'iTn',
    ticker: 'ITANI',
    legacySymbol: 'ITANI',
    displaySymbol: 'ï',
    decimals: 18,
    name: 'iTani',
  },
}

export const calculateAPY = (blockSizeMB) => {
  // Formula: APY = 1% + (BlockSize_MB / 50) × 99%, capped at 100%
  const minAPY = 1
  const maxAPY = 100
  const scalingFactor = blockSizeMB / 50
  const dynamicAPY = minAPY + scalingFactor * 99
  return Math.min(dynamicAPY, maxAPY)
}

export const calculateBlockRewards = (stake, blockSizeMB, isValidator = false) => {
  const apy = calculateAPY(blockSizeMB)
  const yearlyReward = (stake * apy) / 100
  const blockReward = yearlyReward / (365 * 24 * 12) // ~3 sec blocks
  const finalReward = isValidator ? blockReward * 1.5 : blockReward // 50% bonus for validators
  return {
    apy,
    blockReward,
    finalReward,
    yearlyReward,
  }
}

export const formatBalance = (balance, decimals = 18) => {
  const divisor = Math.pow(10, decimals)
  return (parseFloat(balance) / divisor).toFixed(4)
}

export const formatAddress = (address) => {
  if (!address) return ''
  return `${address.slice(0, 6)}...${address.slice(-4)}`
}
